
import BadConscienceDialog from "@/components/thg/BadConscienceDialog.vue";
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { AssetEnum } from "@/lib/AssetRepository";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { Component } from "vue-property-decorator";
import { ImpactTypeEnum } from "./enum/impact-type.enum";
import ThgImpactSelector from "./ThgImpactSelector.vue";

@Component({
  components: {
    LayoutReportStep,
    BadConscienceDialog
  }
})
export default class ThgImpactSelectorRetire extends ThgImpactSelector implements IReportStep {
  screen = ReportScreenEnum.thgImpactSelectorRetire;
  mounted() {
    this.setCurrentStep();
    ThgCreateModule.setActiveImpactTypeItems([ImpactTypeEnum.retire]);
    ThgCreateModule.setImpactType(ImpactTypeEnum.retire);
    ThgCreateModule.setImpactFactor(100);
    if (this.$route.query.campaign) {
      ThgCreateModule.setCampaign((this.$route.query.campaign as string) || "");
    }
  }

  public header: IReportHeaderData = {
    title: "report.thgImpactSelector.titleRetire",
    description: "report.thgImpactSelector.descriptionRetire"
  };

  public instruction: IReportInstructionData = {
    title: "report.thgImpactSelector.instructionTitleRetire",
    text: "report.thgImpactSelector.instructionTextRetire",
    pictures: [AssetEnum.charging],
    example: AssetEnum.charging,
    display: true
  };
}
